import { AttendanceEmployeeType, mapAttendanceEmployeeType } from "./AttendanceEmployeeType";
import { mapPersonalInfoType, PersonalInfoType } from "./PersonalInfoType";
import { mapUserRoleInfoType, UserRoleInfoType } from "./UserRoleInfoType";

export interface SiteEmployeeType {
    attenanceEmployee?: AttendanceEmployeeType | null;
    personalInfo?: PersonalInfoType | null;
    userRoleInfo?: UserRoleInfoType | null;
}


// to single object maping
export const mapSiteEmployeeType = (data: any): SiteEmployeeType => {
    if (!data) {
        throw new Error('Invalid Data')
    }
    const response: SiteEmployeeType = {
        attenanceEmployee: (data.attenanceEmployee !== null) ? mapAttendanceEmployeeType(data.attenanceEmployee) : null,
        personalInfo: (data.personalInfo !== null) ? mapPersonalInfoType(data.personalInfo) : null,
        userRoleInfo: (data.userRoleInfo !== null) ? mapUserRoleInfoType(data.userRoleInfo) : null,
    }
    return response;
}

// maping list objects
export const mapSiteEmployeeTypes = (data: any[]): SiteEmployeeType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    return data.map(mapSiteEmployeeType);
}